import { render, staticRenderFns } from "./addPasswordRedEnvelope.vue?vue&type=template&id=63703b1a&scoped=true&"
import script from "./addPasswordRedEnvelope.vue?vue&type=script&lang=js&"
export * from "./addPasswordRedEnvelope.vue?vue&type=script&lang=js&"
import style0 from "./addPasswordRedEnvelope.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addPasswordRedEnvelope.vue?vue&type=style&index=1&id=63703b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63703b1a",
  null
  
)

component.options.__file = "addPasswordRedEnvelope.vue"
export default component.exports